import HTTP_METHOD from "enums/HTTP_METHOD";
import STATUS_CODE from "enums/STATUS_CODE";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import AuthDto from "types/AuthDto";
import MfaChallengeDto from "types/MfaChallengeDto";

export type AuthResult =
  | { kind: "authenticated"; data: AuthDto }
  | { kind: "mfa_required"; mfa: MfaChallengeDto };

interface AuthPayload {
  email: string;
  password: string;
  deviceToken?: string;
}

export default function usePostAuth() {
  const { write, isWriting, error } = useApiWrite();

  const postAuth = async (payload: AuthPayload): Promise<AuthResult> => {
    const { data, status } = await write<AuthDto | MfaChallengeDto>({
      url: endpoints.postAuth(),
      method: HTTP_METHOD.POST,
      data: payload,
    });

    if (status === STATUS_CODE.ACCEPTED) {
      return {
        kind: "mfa_required",
        mfa: data as MfaChallengeDto,
      };
    }

    return { kind: "authenticated", data: data as AuthDto };
  };

  return {
    postAuth,
    isWriting,
    error,
  };
}
